import { trigger, transition, style, animate } from '@angular/animations';
import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-policies',
  templateUrl: './policies.component.html',
  styleUrls: ['./policies.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('100ms', style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class PoliciesComponent {
  constructor(private readonly cookieService: CookieService) {}

  accepted = false;

  ngOnInit() {
    const accepted = this.cookieService.get('policies');
    if (accepted) this.accepted = true;
  }

  acceptCookies() {
    this.cookieService.set('policies', 'accepted',365);
    this.accepted = true;
  }
}
